import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedVaultService } from '../../services/vault.service';
import * as VaultActions from './vault.actions';

@Injectable()
export class SharedVaultEffects {
  loadVaults$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VaultActions.loadVaults),
      switchMap(({ page = 1, limit = 10, append = false }) =>
        this.sharedVaultService.getVaults(page, limit).pipe(
          map(response => {
            const items = response?.data ?? [];
            const pagination = response?.pagination ?? {
              page,
              limit,
              total: 0,
              totalPages: 0,
            };
            return VaultActions.loadVaultsSuccess({
              data: items,
              pagination,
              append,
            });
          }),
          catchError(error =>
            of(
              VaultActions.loadVaultsFailure({
                error: error.message || 'Failed to load vaults',
              })
            )
          )
        )
      )
    )
  );

  loadWallets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VaultActions.loadWallets),
      switchMap(({ vaultId, page, limit, append = false }) =>
        this.sharedVaultService.getWallets(vaultId, page, limit).pipe(
          map(response =>
            VaultActions.loadWalletsSuccess({
              wallets: response.data,
              pagination: response.pagination,
              append,
            })
          ),
          catchError(error =>
            of(
              VaultActions.loadWalletsFailure({
                error: error?.message || 'Failed to load wallets',
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private sharedVaultService: SharedVaultService,
    private router: Router
  ) {}
}
